document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') return;

  const sliders = document.querySelectorAll('.blog-posts-slider');

  const slideGap = 24;
  const slidesPerView = (el) => {
    const slide = el.querySelector('.swiper-slide');
    const slideWidth = slide ? slide.getBoundingClientRect().width : 0;
    if (!slideWidth || !el.clientWidth) return 1;
    return (el.clientWidth + slideGap) / (slideWidth + slideGap);
  };

  const initSlider = (el) => {
    const wrapper = el.querySelector('.swiper-wrapper');
    const originals = wrapper ? Array.from(wrapper.children) : [];
    if (!wrapper || !originals.length) return;

    const perView = slidesPerView(el);
    const needed = Math.ceil(perView) + 2;
    while (wrapper.children.length < needed) {
      originals.forEach((slide) => wrapper.appendChild(slide.cloneNode(true)));
    }

    new Swiper(el, {
      slidesPerView: perView,
      spaceBetween: slideGap,
      loop: true,
      centeredSlides: false,
      speed: 500,
      watchOverflow: true,
      resizeObserver: false,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
      },
      a11y: { enabled: true },
      on: {
        beforeResize(instance) {
          if (instance.el.clientWidth) instance.params.slidesPerView = slidesPerView(instance.el);
        },
      },
    });
  };

  sliders.forEach((el) => {
    if (!('IntersectionObserver' in window)) {
      initSlider(el);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      initSlider(el);
    }, { rootMargin: '200px 0px' });
    observer.observe(el);
  });
});
